import React from "react";

function useDashboardNavWidth() {
  const [navWidth, setNavWidth] = React.useState(() => parseInt(localStorage.getItem('navWidth')) || 240);
  const [navCollapsed, setNavCollapsed] = React.useState(() => JSON.parse(localStorage.getItem('navCollapsed')) || false);

  React.useEffect(() => {
    function handleResize() {
      setNavWidth(parseInt(localStorage.getItem('navWidth')) || 240);
      setNavCollapsed(JSON.parse(localStorage.getItem('navCollapsed')) || false);
    }
    window.addEventListener('dashboardNavResize', handleResize);
    return () => window.removeEventListener('dashboardNavResize', handleResize);
  }, []);

  return navCollapsed ? 60 : navWidth;
}

const DashboardPageContainer = ({ children }) => {
  const marginLeft = useDashboardNavWidth();
  return (
    <div style={{ minHeight: "100vh", marginLeft: `${marginLeft}px`, background: "#F7FAFC", marginTop: "0", padding: "10px" }}>
      {children}
    </div>
  );
};

export default DashboardPageContainer; 